export enum RecommendationRequestStatusEnum {
  AWAITING = "AWAITING",
  REJECTED = "REJECTED",
  ACCEPTED = "ACCEPTED",
  EXPIRED = "EXPIRED"
}